import { useAuth0 } from "@auth0/auth0-react";
import { Browser } from "@capacitor/browser";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkAcceptedTerms } from "src/api/termsAndConditions";
import { WidgetContext } from "src/contexts/WidgetContext";
import { mobile } from "src/utils/platformUtils";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setIsYahooLoading, leaguePlatforms, setLeaguePlatforms, setYahooToken, yahooToken } = useContext(WidgetContext);
  const { isAuthenticated, isLoading: auth0Loading } = useAuth0();

  // Código existente para web y mobile
  useEffect(() => {
    // Wait for Auth0 to finish loading before determining redirect path
    if (auth0Loading) {
      return;
    }

    // Determine redirect path based on Auth0 authentication status
    // If user is authenticated with Auth0, redirect to /home
    // If user is NOT authenticated (non-logged flow), redirect to / (former /home-free)
    const redirectPath = isAuthenticated ? "/home" : "/";

    // Extract token, refresh_token and expires_in from URL
    console.log("🔄 AuthCallback mounted - Platform:", mobile ? "mobile" : "web");
    console.log("🔍 Current URL:", window.location.href);
    console.log("🔍 Auth0 isAuthenticated:", isAuthenticated, "→ Redirecting to:", redirectPath);

    const urlParams = new URLSearchParams(window.location.search);
    // console.log("🔍 All URL parameters received:", Object.fromEntries(urlParams));

    const error = urlParams.get("error");

    if (error) {
      console.error("🔴 Error en callback de Yahoo:", error);
      setIsYahooLoading(false);

      // make sure yahoo is not appear as connected if there is an error
      const updatedPlatforms = leaguePlatforms.map((platform) => {
        if (platform.id === "Yahoo") {
          return {
            ...platform,
            isLoggedIn: false,
            isSelected: false,
          };
        }
        return platform;
      });
      setLeaguePlatforms(updatedPlatforms);

      if (mobile) {
        navigate(redirectPath, { replace: true });
        Browser.close();
      } else {
        navigate(redirectPath, { replace: true });
      }
      return;
    }

    // console.log("🔍 URL Params:", Object.fromEntries(urlParams));

    const yahoo_token = urlParams.get("token");
    // const token_id = urlParams.get("token_id");
    const expires_in = urlParams.get("expires_in");

    // if there is no yahoo token, redirect to appropriate path and close the browser
    if (!yahoo_token) {
      console.error("❌ Missing required data in callback:", { yahoo_token, expires_in });
      setIsYahooLoading(false);
      if (mobile) {
        navigate(redirectPath, { replace: true });
        Browser.close();
      } else {
        navigate(redirectPath, { replace: true });
      }
      return;
    }

    // console.log("🔍 Yahoo token:", yahoo_token?.substring(0, 10) + "...");
    // console.log("🔍 Token ID:", token_id);
    // console.log("🔍 Expires in:", expires_in);

    // If all parameters are present, navigate to the home page with the token
    const fetchData = async () => {
      // console.log("📥 Starting fetchData in AuthCallback");
      if (yahoo_token && expires_in) {
        try {
          // console.log("📥 Check callback data:", {
          //   token_id,
          //   expires_in,
          //   yahoo_token: yahoo_token.substring(0, 10) + "...",
          // });

          // Save token and token_id in localStorage
          localStorage.setItem("yahoo_token", yahoo_token);
          // localStorage.setItem("yahoo_token_id", token_id);
          // // Save the yahoo token in the context
          setYahooToken(yahoo_token);
          // console.log("🔍 Yahoo token in context:", yahooToken.substring(0, 10) + "...");

          // // Wait for the state in context to update
          // await new Promise((resolve) => setTimeout(resolve, 1000));
          // Set expiration time
          const expirationTime = Date.now() + parseInt(expires_in) * 1000;
          localStorage.setItem("yahoo_token_expiration", expirationTime.toString());

          // Check if the data was saved correctly
          // console.log("💾 Check localStorage after saving:", {
          //   saved_token_id: localStorage.getItem("yahoo_token_id")?.substring(0, 10) + "...",
          //   saved_expiration: localStorage.getItem("yahoo_token_expiration")?.substring(0, 10) + "...",
          // });

          // In mobile, first navigate and then close the browser
          if (mobile) {
            localStorage.setItem("yahoo_callback_active", "true"); // new flag
            if (yahoo_token && expires_in) {
              await navigate(redirectPath, { replace: true });
              await Browser.close();
            }
          } else {
            // In web, now we do the same as mobile: set the flag and navigate to appropriate path
            localStorage.setItem("yahoo_callback_active", "true"); // new flag
            navigate(redirectPath, { replace: true });
          }

          setIsYahooLoading(false);
        } catch (error) {
          console.error("Error in AuthCallback:", error);
          setIsYahooLoading(false);
        }
      } else {
        console.error("❌ Missing required data in callback:", { yahoo_token, expires_in });
        // setIsYahooLoading(false);
      }
    };
    // console.log("this is token_id", token_id);
    fetchData();
  }, [navigate, setIsYahooLoading, leaguePlatforms, setLeaguePlatforms, isAuthenticated, auth0Loading]);

  return <div style={{ color: "black" }}>Processing login...</div>;
};

export default AuthCallback;
